import axios from "axios";
import Form from "./Form";
import Options from "./Options";
import Scroll from "./Scroll";

export default class Widget extends Form
{
	constructor(el)
	{
		super(el);

		this.evaluationInProgress = false;
	}

	static selector = () => `.widget`;

	static addEventListeners()
	{
		document.addEventListener("change", event => {
			if (event.target.matches(`${this.selector()} input`)) {
				new Widget(event.target.closest(this.selector()))
					.refreshState()
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`.widget__submit-button`)) {
				event.preventDefault();
				new Widget(event.target.closest(this.selector()))
					.handleSubmit()
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`.widget__set-kind-button`)) {
				event.preventDefault();
				new Widget(event.target.closest(this.selector()))
					.setKind(event.target.dataset.kind)
					.setAmount(event.target.dataset.kind, event.target.dataset.amount)
					.handleSubmit()
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`.widget__dismiss-amount-alert-button`)) {
				event.preventDefault();
				new Widget(event.target.closest(this.selector()))
					.dismissAmountAlert(event.target.closest(`.widget__amount-alert`).dataset.kind)
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`[name="kind"]`)) {
				new Widget(event.target.closest(this.selector()))
					.disableCustomAmount()
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`[name="amount"]`)) {
				new Widget(event.target.closest(this.selector()))
					.disableCustomAmount()
					.handleSubmit()
			}
		});

		document.addEventListener("click", event => {
			const selector = `.widget__set-slide-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();
				new Widget(event.target.closest(this.selector()))
					.setSlide(event.target.dataset.slide)
			}
		});

		document.addEventListener("click", event => {
			const selector = `.widget__donation-summary`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();
				new Widget(event.target.closest(this.selector()))
					.setSlide("amount")
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`[name="method"]`)) {
				new Widget(event.target.closest(this.selector()))
					.handleSubmit()
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`[name="customAmount"]`)) {
			}
		});
	}

	initialize()
	{
		if (this.el.dataset.pledgeReference.trim()) {
			this.setSlide("confirmation");
		} else if (!this.getSlide()) {
			this.setSlide("amount");
		}

		this.refreshState();
	}

	setLoading()
	{
		this.el.classList.add("widget--loading");
		this.el.querySelector(`.widget__loader`).hidden = false;

		return this;
	}

	unsetLoading()
	{
		this.el.classList.remove("widget--loading");
		this.el.querySelector(`.widget__loader`).hidden = true;

		return this;
	}

	handleSubmit()
	{
		this.setLoading();

		const url = this.getActionUrl();
		const data = this.getData();

		this.resetSlideErrors(this.getSlide());

		axios({
			method: "POST",
			url: url,
			data: data,
			headers: {
				"Accept": "application/json",
			}
		}).then(response => {
			try {
				this.handleResponse(response.data);
			} catch (error) {
				console.error(error);
			}
		}).catch(error => {
			this.setSlideErrors(this.getSlide(), error.response.data);
		}).finally(() => {
			this.unsetLoading();
		});
	}

	handleResponse(response)
	{
		for (let action of response.actions) {
			if (action.type == "setSlide") {
				this.setSlide(action.slide);
			} else if (action.type == "setUrl") {
				window.history.pushState({}, "", action.url);
			} else if (action.type == "redirect") {
				window.top.location.href = action.url;
			} else if (action.type == "scrollToWidget") {
				this.scrollToTop();
			}
		}

		if (response.payment.methods.length == 1) {
			this.setMethod(response.payment.methods[0]);
		}

		this.setFormattedDonation(response.donation.formatted)

		if (response?.pledgeData) {
			this.el.dataset.pledgeAmount = response.pledgeData.amount;
			this.el.dataset.pledgeAmountFormatted = response.pledgeData.amountFormatted;
			this.el.dataset.pledgeAnalyticsAmount = response.pledgeData.analyticsAmount;
			this.el.dataset.pledgeCurrencyCode = response.pledgeData.currencyCode;
			this.el.dataset.pledgeKind = response.pledgeData.kind;
			this.el.dataset.pledgeKindLabel = response.pledgeData.kindLabel;
			this.el.dataset.pledgeReference = response.pledgeData.reference;

			const messageData = {
				event: "pledge.create",
				pledge: {
					activityReference: response.pledgeData.activityReference,
					amount: response.pledgeData.amount,
					campaignReference: response.pledgeData.campaignReference,
					currencyCode: response.pledgeData.currencyCode,
					emailAddress: response.pledgeData.emailAddress,
					firstName: response.pledgeData.firstName,
					kind: response.pledgeData.kind,
					landingPageId: response.pledgeData.landingPageId,
					lastName: response.pledgeData.lastName,
					phone: response.pledgeData.phone,
					reference: response.pledgeData.reference,
					variableSymbol: response.pledgeData.variableSymbol,
				},
			};

			try {
				window.postMessage(messageData, "*");
			} catch (error) {
				console.error(error);
			}

			try {
				window.parent.postMessage(messageData, "*");
			} catch (error) {
				console.error(error);
			}

			this.sendToAnalytics();

			this.el.querySelectorAll(`.summary__property`).forEach(el => {
				try {
					el.innerHTML = response.pledgeData[el.dataset.property];
				} catch (error) {
					// Nevermind.
				}
			});

			if (response?.pledgeData?.qrCodeBase64) {
				this.el.querySelector(`.summary__qrcode .qrcode`).src = response.pledgeData.qrCodeBase64;
			}
		}

		this.refreshState();

		return this;
	}

	setSlide(slide)
	{
		this.el.querySelector(`[name="slide"][value="${slide}"]`).checked = true;
		this.refreshState();

		return this;
	}

	getSlide()
	{
		return this.el.querySelector(`[name="slide"]:checked`).closest(`.widget__slide`).dataset.slide;
	}

	setKind(kind)
	{
		this.el.querySelector(`[name="kind"][value="${kind}"]`).checked = true;
		this.refreshState();

		return this;
	}

	getKind()
	{
		return this.el.querySelector(`[name="kind"]:checked`).value;
	}

	dismissAmountAlert(kind)
	{
		this.el.querySelector(`.widget__amount-alert[data-kind="${kind}"]`).classList.add("widget__amount-alert--dismissed");
		this.refreshState();

		return this;
	}

	setAmount(kind, amount)
	{
		if (new Options(this.el.querySelector(`.widget__slide[data-slide="amount"] .options[data-kind="${kind}"]`)).setOption(amount)) {
			this.disableCustomAmount();
		} else {
			this.enableCustomAmount().setCustomAmount(amount);
		}

		this.refreshState();

		return this;
	}

	enableCustomAmount()
	{
		this.el.querySelector(`.widget__custom-amount-enabled`).checked = true;
		this.refreshState();

		return this;
	}

	disableCustomAmount()
	{
		this.el.querySelector(`.widget__custom-amount-enabled`).checked = false;
		this.setCustomAmount(null);
		this.refreshState();

		return this;
	}

	setCustomAmount(amount)
	{
		let el = this.el.querySelector(`[name="customAmount"]`);
		el.value = amount;

		this.refreshState();

		return this;
	}

	setMethod(method)
	{
		new Options(this.el.querySelector(`.widget__payment-methods`)).setOption(method);

		return this;
	}

	setFormattedDonation(value)
	{
		this.el.querySelectorAll(`.donation-summary__amount`).forEach(el => el.innerHTML = value);

		return this;
	}

	getSlideErrorsElement(slide)
	{
		return this.el.querySelector(`.widget__slide[data-slide="${slide}"] .errors`);
	}

	resetSlideErrors(slide)
	{
		const el = this.getSlideErrorsElement(slide);
		if (el) {
			el.hidden = true;
			el.querySelector(`.errors__messages`).innerHTML = null;
		}

		return this;
	}

	setSlideErrors(slide, errors)
	{
		this.resetSlideErrors(slide);

		const el = this.getSlideErrorsElement(slide);
		for (let error of errors) {
			el.querySelector(`.errors__messages`).innerHTML += `<p>${error.message}</p>`;
			el.hidden = false;
		}

		return this;
	}

	refreshState()
	{
		this.el.querySelectorAll(`[hidden]`).forEach(el => el.hidden = false);

		this.unsetLoading();

		this.el.querySelectorAll(`.errors`).forEach(el => el.hidden = true);
		this.el.querySelectorAll(`[type="radio"][name="slide"]`).forEach(el => el.hidden = true);

		this.el.querySelectorAll(`.widget__slide`).forEach(el => {
			if (el.dataset.slide != this.getSlide()) {
				el.hidden = true;
			}
		});

		this.el.querySelectorAll(`.options`).forEach(el => {
			new Options(el).refreshState();
		});

		/**************************************************************************
		 * Amount.
		 */
		this.el.querySelectorAll(`.title--subtitle`).forEach(el => el.hidden = true);

		this.el.querySelectorAll(`.widget__amounts`).forEach(el => {
			if (el.dataset.kind != this.getKind()) {
				el.hidden = true;
			}
		});

		this.el.querySelectorAll(`.widget__amount-alert`).forEach(el => {
			if (el.dataset.kind != this.getKind()) {
				el.hidden = true;
			}
		});
		this.el.querySelectorAll(`.widget__amount-alert--dismissed`).forEach(el => {
			el.hidden = true;
		});

		this.el.querySelector(`.widget__custom-amount-enabled`).hidden = true;
		this.el.querySelector(`.widget__custom-amount-button`).hidden = this.el.querySelector(`.widget__custom-amount-enabled`).checked;
		this.el.querySelector(`.widget__custom-amount`).hidden = !this.el.querySelector(`.widget__custom-amount-enabled`).checked;

		/**************************************************************************
		 * Confirmation.
		 */
		try {
			this.el.querySelector(`.summary__qrcode`).hidden = (this.el.querySelector(`.summary__qrcode .qrcode`).getAttribute("src") ? false : true);
		} catch (error) {
		}

		try {
			this.el.querySelector(`.summary__qrcode-comment`).hidden = true;
		} catch (error) {
		}

		try {
			this.el.querySelector(`.summary__qrcode-comment--${this.getKind()}`).hidden = false;
		} catch (error) {
		}

		this.sendDimensionMessage();

		return this;
	}

	sendToAnalytics()
	{
		try {
			if (_config.platform == "azure") {
				let purchase = {
					transaction_id: this.el.dataset.pledgeReference,
					affiliation: "Dárce Hnutí DUHA",
					value: parseFloat(this.el.dataset.pledgeAnalyticsAmount),
					currency: this.el.dataset.pledgeCurrencyCode,
					items: [
						{
							item_id: `${this.el.dataset.pledgeKind}_${this.el.dataset.pledgeAmount}_${this.el.dataset.pledgeCurrencyCode}`,
							item_name: `${this.el.dataset.pledgeKindLabel} ${this.el.dataset.pledgeAmountFormatted}`,
							price: parseFloat(this.el.dataset.pledgeAnalyticsAmount),
							quantity: 1,
						},
					],
				};

				dataLayer.push({
					event: "purchase",
					ecommerce: {
						purchase: purchase,
					},
				});
			}
		} catch (error) {
			console.error(error);
		}
	}

	scrollToTop()
	{
		try {
			let scroll = new Scroll(this.el.closest(`.widget-container`));
			scroll.top();
		} catch (error) {
			// Nevermind.
		}
	}

	sendDimensionMessage()
	{
		window.parent.postMessage({
			widget: {
				width: this.el.clientWidth,
				height: this.el.clientHeight,
			}
		}, "*");
	}
}
